import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initStickySidebar() {
  // カレントナビ作成
  createSectionNav();

  // サイドバー固定
  pinSidebar();
}

/**
 * sectionのidを自動取得してセクションナビを動的生成（[id^=sec-]のものに限る）
 */
function createSectionNav() {
  const nav = document.getElementById("js-section-tracker-nav");
  const sectionList = document.querySelectorAll("[id^=sec-]");
  const sectionTitle = document.querySelector(".js-sticky-sidebar-heading");
  if (!nav) return;

  // PC用ナビ
  let htmlTxt = "";
  if (sectionTitle) {
    htmlTxt += `<h2 class="wp-block-heading u-mt-0 u-mb-0">広告を探す</h2>`;
  }
  htmlTxt += '<ul class="p-section-tracker-nav__list">';

  // スマホ用セレクト
  let selectTxt = '<select id="js-section-tracker-select" class="p-section-tracker-select">';
  selectTxt += '<option value="">選択してください</option>';

  sectionList.forEach((section, sIndex) => {
    const h2 = section.querySelector("h3.wp-block-heading");
    const h3List = Array.from(section.querySelectorAll("h4.wp-block-heading"));
    if (!h2) return;

    // H2
    const h2Id = `nav-${section.id}`;
    h2.id = h2Id;

    htmlTxt += `<li class="p-section-tracker-nav__item" data-tracker="${section.id}">
                  <a class="p-section-tracker-nav__link" href="#${h2Id}">${h2.textContent}</a>`;

    selectTxt += `<option value="#${h2Id}">${h2.textContent}</option>`;

    // H3（子見出し）
    if (h3List.length) {
      htmlTxt += `<ul class="p-section-tracker-nav__child-list">`;

      h3List.forEach((h3, i) => {
        const h3Id = `nav-${section.id}-${i}`;
        h3.id = h3Id;

        htmlTxt += `<li class="p-section-tracker-nav__child-item">
                      <a class="p-section-tracker-nav__child-link" href="#${h3Id}">${h3.textContent}</a>
                    </li>`;

        selectTxt += `<option value="#${h3Id}">└ ${h3.textContent}</option>`;
      });
      htmlTxt += "</ul>";
    }
    htmlTxt += "</li>";
  });
  htmlTxt += "</ul>";
  selectTxt += "</select>";

  // PC用ナビとSP用セレクトを両方出力
  nav.innerHTML = htmlTxt + selectTxt;

  // ScrollTrigger: PC用ナビのカレント制御
  sectionList.forEach((section) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top 25%",
      end: "bottom 25%",
      toggleClass: {
        targets: `[data-tracker="${section.id}"]`,
        className: "is-current",
      },
    });
  });

// ヘッダー高さを取得
const getHeaderHeight = () => {
  return document.querySelector(".js-header-fixed")?.clientHeight || 0;
};

// スマホ用セレクトのイベント
const selectEl = document.getElementById("js-section-tracker-select");
if (selectEl) {
  selectEl.addEventListener("change", (e) => {
    const target = document.querySelector(e.target.value);
    if (target) {
      const targetRect = target.getBoundingClientRect().top;
      const headerHeight = getHeaderHeight();
      const offset = 30; // さらに余白を取りたい場合

      const scrollPos = window.scrollY + targetRect - headerHeight - offset;

      window.scrollTo({
        top: scrollPos,
        behavior: "smooth"
      });
    }
  });
}

// PC用アンカーリンク
document.querySelectorAll('.p-section-tracker-nav__link, .p-section-tracker-nav__child-link')
  .forEach(link => {
    link.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();

        const targetRect = target.getBoundingClientRect().top;
        const headerHeight = getHeaderHeight();
        const offset = 30; // さらに余白を取りたい場合

        const scrollPos = window.scrollY + targetRect - headerHeight - offset;

        window.scrollTo({
          top: scrollPos,
          behavior: 'smooth'
        });
      }
    });
  });



}


/**
 * サイドバーをsticky表示
 */
function pinSidebar() {
  const sidebar = document.querySelector(".js-sticky-sidebar-content");
  if (!sidebar) return;

  // メディアクエリを作成
  let mm = gsap.matchMedia();

  mm.add("not all and (max-width: 1024px)", () => {
    // ヘッダーガターを取得（追従時に被らないように）
    let headerGutter = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height-gutter")
      .replace("px", "");
    headerGutter = parseInt(headerGutter, 10);

    gsap.to(".js-sticky-sidebar-content", {
      scrollTrigger: {
        trigger: ".js-sticky-sidebar-content",
        start: "top-=180 top",
        end: () => {
          // サイドバーの高さとメインコンテンツの高さを比較し、終了位置を動的に計算
          const sidebarHeight = document.querySelector(
            ".js-sticky-sidebar-content"
          ).offsetHeight;
          const mainHeight = document.querySelector(
            ".js-has-sticky-sidebar"
          ).offsetHeight;
          return `+=${mainHeight - sidebarHeight}`;
        },
        endTrigger: ".js-has-sticky-sidebar",
        pin: true,
        invalidateOnRefresh: true,
        // markers: true
      },
    });
  });
}
